export const menuBookFeatureTranslationEN = {};
